export type SeverityLevel = 'critical' | 'high' | 'medium' | 'low';

// The highest score still inside each band. Operator-editable on the backend
// under Settings, Business, Risk Scoring, and served by
// GET /api/risks/items/severity-bands/. These defaults match the settings
// defaults and only apply before that fetch lands.
export interface SeverityBands {
  low: number;
  medium: number;
  high: number;
}

export const DEFAULT_BANDS: SeverityBands = { low: 3, medium: 9, high: 15 };

// Module-level rather than context, so every render path stays synchronous.
// useSeverityBands primes it once per session from the API.
let bands: SeverityBands = DEFAULT_BANDS;

export function setSeverityBands(next: SeverityBands): void {
  bands = next;
}

export function getSeverityBands(): SeverityBands {
  return bands;
}

// Complete literals so Tailwind's scanner sees every class.
const SEVERITY_BG: Record<SeverityLevel, string> = {
  critical: 'bg-sev-critical',
  high: 'bg-sev-high',
  medium: 'bg-sev-medium',
  low: 'bg-sev-low',
};

export function severityLevel(score: number): SeverityLevel {
  if (score <= bands.low) return 'low';
  if (score <= bands.medium) return 'medium';
  if (score <= bands.high) return 'high';
  return 'critical';
}

export function severityBgClass(score: number): string {
  return SEVERITY_BG[severityLevel(score)];
}

export function severityLabel(score: number): string {
  const level = severityLevel(score);
  return level.charAt(0).toUpperCase() + level.slice(1);
}
